module.exports = "<div id=\"vertical-menu\" class=\"menu-wrapper\" perfectScrollbar></div>"